import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteAllOrgStructureItems as apiDeleteAll } from "../../api/apiOrgStructureItems";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useDeleteAllOrgStructureItems() {
    const qc = useQueryClient(); const { enqueueSnackbar } = useSnackbar();
    const { mutate: deleteAllOrgStructureItems, isPending: isDelete } = useMutation({
        mutationFn: (req) => apiDeleteAll(req),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); qc.invalidateQueries({ queryKey: ["orgStructureItems"] }); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); },
    });
    return { deleteAllOrgStructureItems, isDelete };
}
